import errors from './errors/index.js';
import translation from './translation/index.js';
const fr = {
    translation,
    errors,
};
export default Object.freeze(fr);
